import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloCaretDownIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path d='M17 7L10 14L3 7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </EloBaseIcon>
)
